webpackJsonp([2],{

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "FKwn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides for handling whether an element is within the viewport. Also
 * lazy-loads a child images with `lazy-src` attribute.
 *
 * @summary In-viewport loading.
 */

/**
 * Transitioning state manager for InView.
 *
 * @class TransitionManager
 */
var TransitionManager = function () {

	/**
  * Creates an instance of TransitionManager.
  *
  * @param {HTMLElement} element The main transitioning element to watch for
  *                              transitioning on.
  */
	function TransitionManager(element) {
		(0, _classCallCheck3.default)(this, TransitionManager);

		this.element = element;

		this._end = this._end.bind(this);
		element.addEventListener('transitionend', this._end);
	}

	/**
  * Return the name of CSS Custom property for the delay value.
  *
  * This a pseudo class constant.
  *
  * @returns {string} The name of CSS Custom property for the delay value,
  *                   including the -- prefix.
  */


	/**
  * @summary Marks the end of the element's transition.
  */
	TransitionManager.prototype._end = function _end() {
		this.element.style.removeProperty(this.CSS_PROPERTY_NAME);
		this.element.removeEventListener('transitionend', this._end);
	};

	/**
  * @summary Marks element as loading (transitioning) in.
  *
  * @param {number} [index=0] The index of the element in the loading
  *                           sequence for staggering effects.
  */


	TransitionManager.prototype.load = function load() {
		var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

		this.element.style.setProperty(this.CSS_PROPERTY_NAME, index * 100 + 'ms');
	};

	(0, _createClass3.default)(TransitionManager, [{
		key: 'CSS_PROPERTY_NAME',
		get: function get() {
			return '--inview-delay';
		}
	}]);
	return TransitionManager;
}();

var _class = function () {

	/**
  * Constructor.
  *
  * @param {HTMLElement[]} elements The elements to manage.
  * @param {number} [threshold=0.2] A number between 0 and 1 as fraction of
  *                                 the element's bounding box that should be
  *                                 visible before it is considered in the
  *                                 viewport.
  */
	function _class(elements) {
		var _this = this;

		var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.2;
		(0, _classCallCheck3.default)(this, _class);

		this.threshold = threshold;

		var observer = window.IntersectionObserver ? new IntersectionObserver(this._onIntersect.bind(this), { threshold: threshold }) : false;

		elements.forEach(function (element, index) {
			element.className += ' ' + _this.constructor.OUTSIDE_VIEWPORT_CLASSNAME;

			element.transitionManager = new TransitionManager(element);

			element._images = (0, _from2.default)(element.querySelectorAll('img[lazy-src]'));
			if (element._images.length) {
				element._images.forEach(function (image) {
					image.classList.add(_this.constructor.IMAGE_UNLOADED_CLASSNAME);
				});
			}

			if (observer) {
				observer.observe(element);
			} else {
				_this.load(element, index);
			}
		});
	}

	/**
  * @summary Not in-view CSS class name.
  *
  * Gets the CSS state class for a element that is not in-view.
  *
  * @returns {string} The CSS state class for a element that is not in-view.
  */


	/**
  * @summary Manages an intersection change.
  *
  * @param {IntersectionObserverEntry[]} entries List of intersection entries.
  * @param {IntersectionObserver} observer The observer managing the change.
  */
	_class.prototype._onIntersect = function _onIntersect(entries, observer) {
		var _this2 = this;

		entries.filter(function (entry) {
			return entry.isIntersecting || entry.intersectionRatio > _this2.threshold;
		}).forEach(function (entry, i) {
			_this2.load(entry.target, i);

			observer.unobserve(entry.target);
		});
	};

	/**
  * @summary Marks an element as in the viewport.
  *
  * @param {HTMLElement} element The element.
  * @param {HTMLImageElement} element._image Optional. The element's
  *                                          associated image (if it has one).
  * @param {number} index The index of the current element in the loaded
  *                       selection, for staggered transition effects.
  */


	_class.prototype.load = function load(element, index) {
		var _this3 = this;

		requestAnimationFrame(function () {

			// Add delays for staggering
			element.transitionManager.load(index);

			element.classList.remove(_this3.constructor.OUTSIDE_VIEWPORT_CLASSNAME);
		});

		if (element._images.length) {
			element._images.forEach(this._loadImage, this);
		}
	};

	/**
  * @summary Loads element's image.
  *
  * Prefix `src` and `srcset` attributes of the image with `lazy-` to have
  * the image available to be be lazy loaded.
  *
  * @param {HTMLImageElement} image The image element to load.
  */


	_class.prototype._loadImage = function _loadImage(image) {
		var _this4 = this;

		// Remove image unloaded class when image is loaded
		image.addEventListener('load', function () {
			image.classList.remove(_this4.constructor.IMAGE_UNLOADED_CLASSNAME);
		});

		// Copy `lazy-` prefixed attributes without the suffix to load the image.
		(0, _from2.default)(image.attributes).filter(function (attribute) {
			return attribute.name.indexOf('lazy-') === 0;
		}).forEach(function (attribute) {
			image.setAttribute(attribute.name.replace(/^lazy-/, ''), attribute.value);
		});
	};

	(0, _createClass3.default)(_class, null, [{
		key: 'OUTSIDE_VIEWPORT_CLASSNAME',
		get: function get() {
			return 'is-outside-viewport';
		}

		/**
   * @summary Unloaded image CSS class name.
   *
   * Gets the CSS state class for a element's image that has not been loaded
   * yet.
   *
   * @returns {string} The CSS state class for a element's image that has not
   *                   been loaded yet.
   */

	}, {
		key: 'IMAGE_UNLOADED_CLASSNAME',
		get: function get() {
			return 'is-image-unloaded';
		}
	}]);
	return _class;
}();

exports.default = _class;

/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ })

});


// WEBPACK FOOTER //
// a9950bfc68d7b7c12b46.js